var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 13.501C4.82475 13.501 6 12.3257 6 10.876C6 9.42623 4.82475 8.25098 3.375 8.25098C1.92525 8.25098 0.75 9.42623 0.75 10.876C0.75 12.3257 1.92525 13.501 3.375 13.501Z",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.514 16.984C7.24891 16.3644 6.848 15.8121 6.34088 15.3681C5.83377 14.9242 5.23339 14.5998 4.5841 14.4189C3.9348 14.2381 3.25317 14.2054 2.58956 14.3233C1.92594 14.4412 1.29727 14.7066 0.75 15.1",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 13.501C22.0747 13.501 23.25 12.3257 23.25 10.876C23.25 9.42623 22.0747 8.25098 20.625 8.25098C19.1753 8.25098 18 9.42623 18 10.876C18 12.3257 19.1753 13.501 20.625 13.501Z",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4861 16.984C16.7512 16.3644 17.1521 15.8121 17.6592 15.3681C18.1663 14.9242 18.7667 14.5998 19.416 14.4189C20.0653 14.2381 20.7469 14.2054 21.4105 14.3233C22.0741 14.4412 22.7028 14.7066 23.2501 15.1",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.501C13.864 13.501 15.375 11.9899 15.375 10.126C15.375 8.26201 13.864 6.75098 12 6.75098C10.136 6.75098 8.625 8.26201 8.625 10.126C8.625 11.9899 10.136 13.501 12 13.501Z",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7149 17.2499C16.1462 16.5475 15.4278 15.9811 14.6121 15.592C13.7964 15.2029 12.9041 15.001 12.0004 15.001C11.0967 15.001 10.2043 15.2029 9.38867 15.592C8.57299 15.9811 7.85456 16.5475 7.28589 17.2499",
    stroke: "#60E5E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.541b9512.svg";
export { ForwardRef as ReactComponent };